<template>
  <div class="expandable-type-transactions">
    <template v-if="isPredictedTransaction">
      <predicted-transaction v-for="transaction in transactions"
                             :predicted-transaction="transaction"
                             :can-edit-category="!outOfDate"
                             :out-of-date="outOfDate"
                             :category-name="categoryName"
                             :category-id="useCategoryId ? categoryId : null"
                             v-bind:key="transaction.transactionId">
      </predicted-transaction>
    </template>
    <template v-else>
      <transaction v-for="transaction in transactions"
                   :transaction="transaction"
                   :can-edit-category="!outOfDate"
                   :out-of-date="outOfDate"
                   :category-name="categoryName"
                   :type="categoryType"
                   :category-id="useCategoryId ? categoryId : null"
                   v-bind:key="transaction.transactionId">
      </transaction>
    </template>
  </div>
</template>

<script>
import Transaction from './Transaction.vue';
import PredictedTransaction from './PredictedTransaction.vue';

export default {
  name: 'CashflowTypeTransactions',
  components: {
    Transaction,
    PredictedTransaction,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
    categoryName: {
      type: String,
    },
    outOfDate: {
      type: Boolean,
      default: false,
    },
    useCategoryId: {
      type: Boolean,
      default: false,
    },
    isPredictedTransaction: {
      type: Boolean,
      default: false,
    },
    categoryType: {
      type: String,
      required: false,
    },
  },
  computed: {
    transactions() {
      return this.category.transactions;
    },
    categoryId() {
      return this.category.categoryId;
    },
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
</style>
